<span *ngIf="multiData.type === 'TikZ'">
  <span style="display: flex; align-items: center">
    <span [id]="multiData.tikzId"> </span>
  </span>
</span>
<span *ngIf="multiData?.type == 'MathJax' && multiData?.data">
  <span [mathjax]="multiData.data"></span>
</span>
<span *ngIf="multiData.type == 'Katex'">
  <ng-katex [equation]="multiData.data"></ng-katex>
</span>
<span *ngIf="multiData.type == 'URL'">
  <img [src]="multiData.data" />
</span>
<span *ngIf="multiData.type === 'Images'">
  <img
    *ngFor="let image of multiData.imageKeys"
    [src]="multiData.listOfImages ? multiData.listOfImages[image] : ''"
    style="
      display: block;
      margin-bottom: 10px;
      max-height: 300px;
      max-width: 300px;
    "
  />
</span>
<span *ngIf="multiData.type === 'Videos'">
  <ng-container *ngFor="let video of multiData.videos">
    <div
      *ngIf="multiData.videoMap?.get(video.videoId)?.isActive"
      style="margin-bottom: 20px"
    >
      <img
        *ngIf="!video.isActive; else thumbnail"
        src="assets/Play-circle.png"
        class="video-thumb-img"
        (click)="video.isActive = true"
      />
      <ng-template #thumbnail>
        <div class="video-player-wrapper">
          <iframe
            [src]="multiData.videoMap?.get(video.videoId)?.safeBunnyUrl || ''"
            width="100%"
            height="250"
            frameborder="0"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
            class="video-player"
          >
          </iframe>

          <button (click)="video.isActive = false" class="close-video-btn">
            X
          </button>
        </div>
      </ng-template>
    </div>
  </ng-container>
</span>
